import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({
  scale,
  verticalOffset = 0,
  gradientStop1 = '#B96F29',
  gradientStop2 = '#3B2314',
}) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`
  const transformOrigin = '20.42 8.52'

  return (
    <g transform={`scale(${scale},${scale}) translate(0,${verticalOffset})`} transform-origin={transformOrigin}>
      <path
        d="M9.11969 15.9901C13.2287 15.9901 16.5597 12.659 16.5597 8.55005C16.5597 4.44105 13.2287 1.11011 9.11969 1.11011C5.01069 1.11011 1.67969 4.44105 1.67969 8.55005C1.67969 12.659 5.01069 15.9901 9.11969 15.9901Z"
        fill={`url(#${randomGradientId1})`}
      />
      <path
        d="M31.6597 15.9901C35.7687 15.9901 39.0997 12.659 39.0997 8.55005C39.0997 4.44105 35.7687 1.11011 31.6597 1.11011C27.5507 1.11011 24.2197 4.44105 24.2197 8.55005C24.2197 12.659 27.5507 15.9901 31.6597 15.9901Z"
        fill={`url(#${randomGradientId2})`}
      />
      <path
        d="M9.18951 15.92C13.2985 15.92 16.6295 12.5891 16.6295 8.4801C16.6295 4.3711 13.2985 1.04004 9.18951 1.04004C5.08052 1.04004 1.74951 4.3711 1.74951 8.4801C1.74951 12.5891 5.08052 15.92 9.18951 15.92Z"
        stroke="#FCE5AC"
        strokeWidth="0.75"
        strokeMiterlimit="10"
        fill="none"
      />
      <path
        d="M31.7296 15.92C35.8386 15.92 39.1696 12.5891 39.1696 8.4801C39.1696 4.3711 35.8386 1.04004 31.7296 1.04004C27.6206 1.04004 24.2896 4.3711 24.2896 8.4801C24.2896 12.5891 27.6206 15.92 31.7296 15.92Z"
        stroke="#FCE5AC"
        strokeWidth="0.75"
        strokeMiterlimit="10"
        fill="none"
      />
      <path
        d="M16.6294 8.48012C16.6294 8.48012 20.3094 7.18012 24.2294 8.48012"
        stroke="#FCE5AC"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M1.55981 9.03003H0.0698242" stroke="#FCE5AC" strokeWidth="0.75" strokeMiterlimit="10" />
      <path d="M40.79 9.03003H39.29" stroke="#FCE5AC" strokeWidth="0.75" strokeMiterlimit="10" />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="9.12419"
          y1="0.170607"
          x2="9.12419"
          y2="13.232"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={gradientStop1} />
          <stop offset="1" stopColor={gradientStop2} />
        </linearGradient>
        <linearGradient
          id={randomGradientId2}
          x1="31.6643"
          y1="0.170607"
          x2="31.6643"
          y2="13.232"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={gradientStop1} />
          <stop offset="1" stopColor={gradientStop2} />
        </linearGradient>
      </defs>
    </g>
  )
}
